import { useEffect } from 'react'
import { useAuth } from 'react-oidc-context'
import { useNavigate } from 'react-router-dom'

/**
 * Landing page for the OIDC redirect_uri (/callback).
 * react-oidc-context processes the authorization code automatically when it
 * detects the callback URL params. This component just waits for that to
 * complete, then sends the user to their original destination (preserved in
 * OIDC state) or falls back to /.
 */
export function OidcCallback() {
  const auth = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    if (!auth.isLoading && auth.isAuthenticated) {
      // react-oidc-context restores the pre-login path via `state.returnTo`
      const returnTo =
        (auth.user?.state as { returnTo?: string } | undefined)?.returnTo ?? '/'
      navigate(returnTo, { replace: true })
    }
  }, [auth.isLoading, auth.isAuthenticated, auth.user, navigate])

  if (auth.error) {
    return (
      <div className="flex min-h-screen items-center justify-center bg-canvas">
        <div className="text-center">
          <p className="font-sans text-sm text-fg-secondary">Login failed</p>
          <p className="mt-1 font-mono text-xs text-fg-secondary">{auth.error.message}</p>
        </div>
      </div>
    )
  }

  return (
    <div className="flex min-h-screen items-center justify-center bg-canvas">
      <span className="font-sans text-sm text-fg-secondary">Completing login…</span>
    </div>
  )
}
